
export const userStates = {
  isProcessing: "Checking",
};